import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import { withRouter, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

// Import icons
import workplace from "assets/images/svg/workplace.svg";
import wastebasket from "assets/images/svg/wastebasket.svg";
import warning from "assets/images/svg/warning.svg";
import tms from "assets/images/svg/tms.svg";
import person from "assets/images/svg/person.svg";
import notice from "assets/images/svg/notice.svg";
import message from "assets/images/svg/message.svg";
import maindelete from "assets/images/svg/maindelete.svg";
import lock from "assets/images/svg/lock.svg";
import financial from "assets/images/svg/financial.svg";
import download from "assets/images/svg/download.svg";
import del from "assets/images/svg/delete.svg";
import data from "assets/images/svg/data.svg";
import dashboard from "assets/images/svg/dashboard.svg";
import correspondent from "assets/images/svg/correspondent.svg";
import contract from "assets/images/svg/contract.svg";
import checked from "assets/images/svg/checked.svg";

const SidebarContent = () => {
  const selector = useSelector((state) => state);
  const location = useLocation();

  const [type, setType] = React.useState(selector.auth.user?.type || "");
  const [detailType, setDetailType] = React.useState(
    selector.auth?.user?.member_group?.[0]?.company_group?.company_detail?.[0]
      ?.type || ""
  );
  const [companyDetail, setCompanyDetail] = React.useState(
    selector.auth?.user?.member_group?.[0]?.company_group?.company_detail?.[0]
  );

  const emitter = [
    [
      { link: "/chart-history", text: "차트" },
      { link: "/trade-history", text: "수거내역" },
    ],
    [
      {
        link:
          companyDetail?.is_payment_total === "Y"
            ? "/emitter-bill-all"
            : "/emitter-bill",
        text: "청구서",
      },
      { link: "/settlement-details", text: "정산/고지 내역" },
    ],
    [],
    [
      { link: "/profile-screen", text: "회원정보" },
      { link: "/service-center-screen", text: "고객센터" },
      { link: "/contract-management-screen", text: "계약서 관리" },
      { link: "/business-management-screen", text: "기본정보 관리" },
      { link: "/withdrawl-user", text: "회원탈퇴" },
    ],
  ];

  const emitterMany = [
    [
      { link: "/chart-history", text: "차트" },
      { link: "/trade-history", text: "수거내역" },
      { link: "/allbaro-process", text: "올바로 처리내역" },
    ],
    [
      {
        link:
          companyDetail?.is_payment_total === "Y"
            ? "/emitter-bill-all"
            : "/emitter-bill",
        text: "청구서",
      },
      { link: "/settlement-details", text: "정산/고지 내역" },
    ],
    [],
    [
      { link: "/profile-screen", text: "회원정보" },
      { link: "/service-center-screen", text: "고객센터" },
      { link: "/contract-management-screen", text: "계약서 관리" },
      { link: "/business-management-screen", text: "사업장 관리" },
      { link: "/report-management-screen", text: "신고사항 관리" },
      { link: "/withdrawl-user", text: "회원탈퇴" },
    ],
  ];

  const emitterMulti = [
    [],
    [],
    [],
    [
      { link: "/profile-screen", text: "회원정보" },
      { link: "/service-center-screen", text: "고객센터" },
      { link: "/contract-management-screen", text: "계약서 관리" },
      { link: "/business-management-screen", text: "기본정보 관리" },
      { link: "/business-management-list-screen", text: "사업장 관리" },
      { link: "/withdrawl-user", text: "회원탈퇴" },
    ],
  ];

  const emitterTotal = [
    [],
    [],
    [],
    [
      { link: "/profile-screen", text: "회원정보" },
      { link: "/service-center-screen", text: "고객센터" },
      { link: "/contract-management-screen", text: "계약서 관리" },
      { link: "/business-management-screen", text: "기본정보 관리" },
      { link: "/business-company-total-list", text: "사업장 관리" },
      { link: "/report-management-screen", text: "신고사항 관리" },
      { link: "/withdrawl-user", text: "회원탈퇴" },
    ],
  ];

  const collection = [
    {
      text: "대시보드",
      icon: dashboard,
      link: "/dashboard",
      sub: null,
    },
    {
      text: "거래처관리",
      icon: correspondent,
      link: "/correspondent-management",
      sub: null,
    },
    {
      text: "수거관리",
      icon: wastebasket,
      link: "/#",
      sub: [
        { link: "/collect-history", text: "수거내역 관리" },
        { link: "/dispose-history", text: "인계내역 관리" },
        { link: "/allbaro-process", text: "올바로 처리내역" },
        { link: "/collect-schedule", text: "수거 스케줄 관리" },
      ],
    },
    {
      text: "수거현황(TMS)",
      icon: tms,
      link: "/tms",
      sub: null,
    },
    {
      text: "계약관리",
      icon: contract,
      link: "/contract-management-screen",
      sub: null,
    },
    {
      text: "정산관리",
      icon: financial,
      link: "/#",
      sub: [
        { link: "/settlement-management", text: "거래처 정산관리" },
        { link: "/treatment-settlement-management", text: "처리장 정산관리" },
        { link: "/invoicing-management", text: "청구서 발행 관리" },
      ],
    },
    {
      text: "메시지 관리",
      icon: message,
      link: "/#",
      sub: [
        { link: "/sms-shipping-management", text: "SMS 발송관리" },
        { link: "/email-shipping-management", text: "Email 발송관리" },
        { link: "/template-management", text: "템플릿 관리" },
      ],
    },
    {
      text: "사업장 관리",
      icon: workplace,
      link: "/#",
      sub: [
        { link: "/workplace-management", text: "사업장 관리" },
        { link: "/treatment-management", text: "처리장 관리" },
        { link: "/collection-area-management", text: "수거구역 관리" },
      ],
    },
    {
      text: "지입계약",
      icon: contract,
      link: "/outsourcing-contract-management-screen",
      sub: null,
    },
    {
      text: "공지사항",
      icon: notice,
      link: "/notice",
      sub: null,
    },
    {
      text: "자료실",
      icon: data,
      link: "/data-room",
      sub: null,
    },
  ];

  const treatment = [
    {
      text: "대시보드",
      icon: dashboard,
      link: "/dashboard",
      sub: null,
    },
    {
      text: "거래처관리",
      icon: correspondent,
      link: "/correspondent-management",
      sub: null,
    },
    {
      text: "관리대장",
      icon: contract,
      link: "/#",
      sub: [
        { link: "/wearing-history", text: "인계내역" },
        { link: "/process-history", text: "처리내역" },
      ],
    },
    {
      text: "정산관리",
      icon: financial,
      link: "/treatment-settlement-management",
      sub: null,
    },
    {
      text: "사업장 관리",
      icon: data,
      link: "/workplace-management",
      sub: null,
    },
    {
      text: "거래소 상품 관리",
      icon: workplace,
      link: "/platform-product-screen",
      sub: null,
    },
    {
      text: "내 상품 관리",
      icon: workplace,
      link: "/my-product-screen",
      sub: null,
    },
    // {
    //   text: "수거관리",
    //   icon: wastebasket,
    //   link: "/#",
    //   sub: [
    //     { link: "/collect-history", text: "수거내역 관리" },
    //     { link: "/dispose-history", text: "인계내역 관리" },
    //     { link: "/allbaro-process", text: "올바로 처리내역" },
    //     { link: "/collect-schedule", text: "수거 스케줄 관리" },
    //   ],
    // },
    // {
    //   text: "수거현황(TMS)",
    //   icon: tms,
    //   link: "/tms",
    //   sub: null,
    // },
    // {
    //   text: "계약관리",
    //   icon: contract,
    //   link: "/contract-management-screen",
    //   sub: null,
    // },
    // {
    //   text: "정산관리",
    //   icon: financial,
    //   link: "/#",
    //   sub: [
    //     { link: "/settlement-management", text: "거래처 정산관리" },
    //     { link: "/treatment-settlement-management", text: "처리장 정산관리" },
    //     { link: "/invoicing-management", text: "청구서 발행 관리" },
    //   ],
    // },
    // {
    //   text: "메시지 관리",
    //   icon: message,
    //   link: "/#",
    //   sub: [
    //     { link: "/sms-shipping-management", text: "SMS 발송관리" },
    //     { link: "/email-shipping-management", text: "Email 발송관리" },
    //     { link: "/template-management", text: "템플릿 관리" },
    //   ],
    // },
    // {
    //   text: "사업장 관리",
    //   icon: workplace,
    //   link: "/#",
    //   sub: [
    //     { link: "/workplace-management", text: "사업장 관리" },
    //     { link: "/treatment-management", text: "처리장 관리" },
    //     { link: "/collection-area-management", text: "수거구역 관리" },
    //   ],
    // },
    // {
    //   text: "지입계약",
    //   icon: contract,
    //   link: "/outsourcing-contract-management-screen",
    //   sub: null,
    // },
    // {
    //   text: "공지사항",
    //   icon: notice,
    //   link: "/notice",
    //   sub: null,
    // },
    // {
    //   text: "자료실",
    //   icon: data,
    //   link: "/data-room",
    //   sub: null,
    // },
  ];

  // const treatment = [
  //   [
  //     { link: "/wearing-history", text: "인계내역" },
  //     { link: "/process-history", text: "처리내역" },
  //   ],
  //   [],
  //   [],
  //   [
  //     { link: "/profile-screen", text: "회원정보" },
  //     { link: "/service-center-screen", text: "고객센터" },
  //     { link: "/contract-management-screen", text: "계약서 관리" },
  //     { link: "/business-management-screen", text: "사업장 관리" },
  //     { link: "/report-management-screen", text: "신고사항 관리" },
  //     { link: "/platform-product-screen", text: "거래소 상품 관리" },
  //     { link: "/my-product-screen", text: "내 상품 관리" },
  //     { link: "/withdrawl-user", text: "회원탈퇴" },
  //   ],
  // ];

  const demand = [
    [],
    [],
    [],
    [
      { link: "/profile-screen", text: "회원정보" },
      { link: "/service-center-screen", text: "고객센터" },
      { link: "/business-management-screen", text: "사업장 관리" },
      { link: "/my-product-screen", text: "내 상품 관리" },
      { link: "/withdrawl-user", text: "회원탈퇴" },
    ],
  ];

  const driver = [
    [],
    [],
    [],
    [
      { link: "/profile-screen", text: "회원정보" },
      { link: "/service-center-screen", text: "고객센터" },
    ],
  ];

  const ref = useRef();

  useEffect(() => {
    const initMenu = () => {
      const menu = new MetisMenu("#side-menu");
      const pathName = location.pathname;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");

      let matchingMenuItem = null;
      for (let i = 0; i < items.length; ++i) {
        const itemPath = new URL(items[i].href, window.location.origin).pathname;
        if (pathName.includes(itemPath) && itemPath !== "/") {
          matchingMenuItem = items[i];
          break;
        }
      }

      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };

    initMenu();
    return () => {
      const ul = document.getElementById("side-menu");
      if (ul) {
        ul.querySelectorAll(".mm-active, .mm-show").forEach((el) => {
          el.classList.remove("mm-active", "mm-show");
        });
      }
    };
  }, [location.pathname, type]);

  useEffect(() => {
    if (ref.current) {
      ref.current.recalculate();
    }
  }, [type, collection]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("mm-active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");
        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active");
          parent3.childNodes[0].classList.add("mm-active");
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show");
              parent5.childNodes[0].classList.add("mm-active");
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {type === "emitter" &&
              detailType !== "total" &&
              detailType !== "multi" &&
              detailType !== "many" && (
                <>
                  <li>
                    <Link to="/dashboard" className="waves-effect">
                      <i className="ti-home"></i>
                      <span>{"관리 홈"}</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/#"
                      className="has-arrow waves-effect"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="ti-zip"></i>
                      <span>{"관리대장"}</span>
                    </Link>
                    <ul className="sub-menu" aria-expanded="false">
                      {emitter[0].map((item, index) => (
                        <li key={index}>
                          <Link to={item.link}>{item.text}</Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                  <li>
                    <Link
                      to="/#"
                      className="has-arrow waves-effect"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="ti-clipboard"></i>
                      <span>{"청구서"}</span>
                    </Link>
                    <ul className="sub-menu" aria-expanded="false">
                      {emitter[1].map((item, index) => (
                        <li key={index}>
                          <Link to={item.link}>{item.text}</Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                  <li>
                    <Link to="/TMS" className="waves-effect">
                      <i className="ti-location-pin"></i>
                      <span>{"TMS"}</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/#"
                      className="has-arrow waves-effect"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="ti-heart"></i>
                      <span>{"마이웨버"}</span>
                    </Link>
                    <ul className="sub-menu" aria-expanded="false">
                      {emitter[3].map((item, index) => (
                        <li key={index}>
                          <Link to={item.link}>{item.text}</Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                </>
              )}

            {type === "emitter" && detailType === "many" && (
              <>
                <li>
                  <Link to="/dashboard" className="waves-effect">
                    <i className="ti-home"></i>
                    <span>{"관리 홈"}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/#"
                    className="has-arrow waves-effect"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="ti-zip"></i>
                    <span>{"관리대장"}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    {emitterMany[0].map((item, index) => (
                      <li key={index}>
                        <Link to={item.link}>{item.text}</Link>
                      </li>
                    ))}
                  </ul>
                </li>
                <li>
                  <Link
                    to="/#"
                    className="has-arrow waves-effect"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="ti-clipboard"></i>
                    <span>{"청구서"}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    {emitterMany[1].map((item, index) => (
                      <li key={index}>
                        <Link to={item.link}>{item.text}</Link>
                      </li>
                    ))}
                  </ul>
                </li>
                <li>
                  <Link to="/TMS" className="waves-effect">
                    <i className="ti-location-pin"></i>
                    <span>{"TMS"}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/#"
                    className="has-arrow waves-effect"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="ti-heart"></i>
                    <span>{"마이웨버"}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    {emitterMany[3].map((item, index) => (
                      <li key={index}>
                        <Link to={item.link}>{item.text}</Link>
                      </li>
                    ))}
                  </ul>
                </li>
              </>
            )}

            {type === "emitter" && detailType === "multi" && (
              <>
                <li>
                  <Link to="/dashboard" className="waves-effect">
                    <i className="ti-home"></i>
                    <span>{"관리 홈"}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/business-list" className="waves-effect">
                    <i className="ti-zip"></i>
                    <span>{"관리대장"}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/report-list" className="waves-effect">
                    <i className="ti-clipboard"></i>
                    <span>{"청구서"}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/TMS" className="waves-effect">
                    <i className="ti-location-pin"></i>
                    <span>{"TMS"}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/#"
                    className="has-arrow waves-effect"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="ti-heart"></i>
                    <span>{"마이웨버"}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    {emitterMulti[3].map((item, index) => (
                      <li key={index}>
                        <Link to={item.link}>{item.text}</Link>
                      </li>
                    ))}
                  </ul>
                </li>
              </>
            )}

            {type === "emitter" && detailType === "total" && (
              <>
                <li>
                  <Link to="/dashboard" className="waves-effect">
                    <i className="ti-home"></i>
                    <span>{"관리 홈"}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/company-total-list" className="waves-effect">
                    <i className="ti-zip"></i>
                    <span>{"관리대장"}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/report-total-list" className="waves-effect">
                    <i className="ti-clipboard"></i>
                    <span>{"청구서"}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/TMS" className="waves-effect">
                    <i className="ti-location-pin"></i>
                    <span>{"TMS"}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/#"
                    className="has-arrow waves-effect"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="ti-heart"></i>
                    <span>{"마이웨버"}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    {emitterTotal[3].map((item, index) => (
                      <li key={index}>
                        <Link to={item.link}>{item.text}</Link>
                      </li>
                    ))}
                  </ul>
                </li>
              </>
            )}

            {type === "collection" && collection.map((item, index) => (
              <li key={"collection_menu_" + index}>
                <Link
                  to={item.link}
                  className={`waves-effect d-flex align-items-center`}
                  onClick={(e) => {
                    if (item.sub) {
                      e.preventDefault();
                    }
                  }}
                >
                  <div className="sidebar-icon-frame">
                    <img src={item.icon} alt={item.text} />
                  </div>
                  <span>{item.text}</span>
                </Link>
                {item.sub && (
                  <ul className="sub-menu" aria-expanded="false">
                    {item.sub.map((subItem, subIndex) => (
                      <li key={"collection_submenu_" + index + subIndex}>
                        <Link to={subItem.link}>ㆍ{subItem.text}</Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}

            {type === "treatment" && treatment.map((item, index) => (
              <li key={"treatment_menu_" + index}>
                <Link
                  to={item.link}
                  className={`waves-effect d-flex align-items-center`}
                  onClick={(e) => {
                    if (item.sub) {
                      e.preventDefault();
                    }
                  }}
                >
                  <div className="sidebar-icon-frame">
                    <img src={item.icon} alt={item.text} />
                  </div>
                  <span>{item.text}</span>
                </Link>
                {item.sub && (
                  <ul className="sub-menu" aria-expanded="false">
                    {item.sub.map((subItem, subIndex) => (
                      <li key={"treatment_submenu_" + index + subIndex}>
                        <Link to={subItem.link}>ㆍ{subItem.text}</Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}

            {type === "demand" && (
              <>
                <li>
                  <Link to="/dashboard" className="waves-effect">
                    <i className="ti-home"></i>
                    <span>{"관리 홈"}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/exchange-platform" className="waves-effect">
                    <i className="ti-money"></i>
                    <span>{"거래소"}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/#"
                    className="has-arrow waves-effect"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="ti-heart"></i>
                    <span>{"마이웨버"}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    {demand[3].map((item, index) => (
                      <li key={index}>
                        <Link to={item.link}>{item.text}</Link>
                      </li>
                    ))}
                  </ul>
                </li>
              </>
            )}

            {type === "driver" && (
              <>
                <li>
                  <Link to="/dashboard" className="waves-effect">
                    <i className="ti-home"></i>
                    <span>{"관리 홈"}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/dispose-screen" className="waves-effect">
                    <i className="ti-zip"></i>
                    <span>{"인계내역"}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/TMS" className="waves-effect">
                    <i className="ti-location-pin"></i>
                    <span>{"TMS"}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/#"
                    className="has-arrow waves-effect"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="ti-heart"></i>
                    <span>{"마이웨버"}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    {driver[3].map((item, index) => (
                      <li key={index}>
                        <Link to={item.link}>{item.text}</Link>
                      </li>
                    ))}
                  </ul>
                </li>
              </>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

export default withRouter(SidebarContent);